import { keycloak } from '#shared/lib/auth'
import { Role } from '#shared/model'
import getTgBotRole from './get-tg-bot-role'

interface RoleInfo {
  role: Role | 'unknown'
  isGiven: boolean
}

export default function getCurrentUserRoleInfo(): RoleInfo {
  let prefferedRole: unknown = keycloak.tokenParsed?.preferredRole
  if (import.meta.env.PUBLIC_PLATFORM === 'telegram') {
    prefferedRole = getTgBotRole()
  }

  const givenRoles = keycloak.tokenParsed?.realm_access?.roles || []

  const hasGivenClientRole = givenRoles.includes('client')
  const hasGivenStaffRole = givenRoles.includes('staff')
  const hasGivenSupportRole = givenRoles.includes('support')
  const hasGivenManagerRole = givenRoles.includes('manager')

  const hasGivenRole = hasGivenClientRole || hasGivenStaffRole || hasGivenSupportRole || hasGivenManagerRole

  const givenRole = (() => {
    if (prefferedRole === 'client' && hasGivenClientRole) return 'client'
    if (prefferedRole === 'staff' && hasGivenStaffRole) return 'staff'
    if (hasGivenManagerRole) return 'manager'
    if (hasGivenSupportRole) return 'support'
    return 'unknown'
  })()

  if (hasGivenRole) {
    return {
      role: givenRole,
      isGiven: true,
    }
  }

  if (prefferedRole === 'client' || prefferedRole === 'staff') {
    return {
      role: prefferedRole,
      isGiven: false,
    }
  }

  return {
    role: 'unknown',
    isGiven: false,
  }
}
